import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import VolunteerZone from './pages/VolunteerZone';
import Header from './components/Header';

function App() {
  return (
    <div className="App pt-20">
      <Header />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/volunteer-zone" element={<VolunteerZone />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
